import { render, staticRenderFns } from "./MedicalRequirementsPlanDelete.vue?vue&type=template&id=2734038b&scoped=true&"
import script from "./MedicalRequirementsPlanDelete.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2734038b",
  null
  
)

export default component.exports